import { useStyles } from './styles';
import { useTheme } from "../../hooks/useTheme";

import backImg from '../../assets/back.svg'
import { useHistory } from 'react-router-dom';
function TopBar({ children }) {
  const { themeColor } = useTheme();
  const classes = useStyles(themeColor);
  let history = useHistory();
  window.scrollTo(0, 0);
  return (
    <div className={classes.container}>
      <img src={backImg} alt="Voltar" onClick={() => history.goBack()}/>
      {children}
    </div>
  );
}

export default TopBar;